import BlockSectionHeader from './sectionHeader'

export default BlockSectionHeader
